import React, { useState } from "react";
import { Button, Input, InputNumber } from "antd";
import { visitApiUpsellProvider } from "../../lib/api/providers";
import { handleError } from "../../modules/presence/api/api";

const ModifyKpiResponses = ({ record, question }) => {
  const { itemId, path = {}, visitId = "" } = record;
  const { response, kpiFormat, kpiId } = record[question];

  const [amount, setAmount] = useState(response);
  const [comment, setComment] = useState(response);
  const [isLoading, setIsLoading] = useState(false);

  const onSave = async newResponse => {
    setIsLoading(true);
    try {
      await visitApiUpsellProvider.post(`/modifykpiresponse/${visitId}`, {
        itemId,
        kpiId,
        newResponse,
        ...path
      });
      window.location.reload(false);
      setIsLoading(false);
    } catch (e) {
      handleError(e);
      console.log(e);
      setAmount(response);
      setComment(response);
      setIsLoading(false);
    }
  };
  if (kpiFormat.toLowerCase() === "num") {
    return (
      <div className="flex mt-1">
        <InputNumber
          style={{
            backgroundColor: "#f0f0f0",
            borderRadius: "11px",
            borderColor: "#f0f0f0",
            width: "100px",
            marginRight: 5
          }}
          type="number"
          value={amount}
          onChange={setAmount}
        />
        {amount !== response && (
          <Button
            type={"primary"}
            onClick={() => {
              onSave(amount);
            }}
            className="cursor-pointer bg-green-400 text-white mx-2 px-2 py-2"
          >
            {isLoading ? "loading" : "Enregistrer"}
          </Button>
        )}
      </div>
    );
  }

  if (kpiFormat.toLowerCase() === "text") {
    return (
      <div className="flex mt-1">
        <Input
          style={{
            backgroundColor: "#f0f0f0",
            borderRadius: "11px",
            borderColor: "#f0f0f0",
            width: "300px"
          }}
          value={comment}
          onChange={item => {
            setComment(item.target.value);
          }}
        />
        {comment !== response && (
          <Button
            type={"primary"}
            onClick={() => {
              onSave(comment);
            }}
            className="cursor-pointer bg-green-400 text-white mx-2 px-2 py-2"
          >
            {isLoading ? "loading" : "Enregistrer"}
          </Button>
        )}
      </div>
    );
  }
  return <div>[modification not available yet]</div>;
};

export default ModifyKpiResponses;



// WEBPACK FOOTER //
// src/components/visit/ModifyKpiResponses.js